import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetActivities } from '@/hooks/v1';
import type { InputDefaultProps } from '../../../types';
import { ActivitySelect } from '@/components/ui/Inputs/ActivitySelect';
import { FormItem } from '@/components/ui/Inputs/FormItem';

const { useFormInstance, useWatch } = Form;

export function Activity({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const form = useFormInstance();

	const organizationId = useWatch([fieldName, 'organization_id'], form);
	const companyId = useWatch([fieldName, 'company_id'], form);
	const workstationId = useWatch([fieldName, 'workstation_id'], form);
	const activityId = useWatch([fieldName, 'activity_id'], form);

	const {
		data: activities,
		isLoading,
		isFetching,
		isError
	} = useGetActivities({
		organization_id: organizationId,
		company_id: companyId,
		workstation_id: workstationId
	});

	function handleSelectActivities(id: string): void {
		form.setFieldValue([fieldName, 'activity_id'], id);
	}

	function handleClearActivities(): void {
		form.setFieldValue([fieldName, 'activity_id'], undefined);
	}

	return (
		<Col xs={24}>
			<FormItem
				title="Activity"
				fontSize={fontSize}
				isRequired={isRequired}
				namePath={[fieldName, 'activity_id']}
				errorMessage={I18n.get('Select an activity')}
			>
				<ActivitySelect
					size="large"
					allowCreation
					loading={isFetching}
					options={activities}
					companyId={companyId}
					activityId={activityId}
					workstationId={workstationId}
					organizationId={organizationId}
					fieldName={[fieldName, 'activity_id']}
					handleSelectActivity={handleSelectActivities}
					handleClearActivities={handleClearActivities}
					disabled={isLoading || isFetching || isError || !workstationId || disabled}
				/>
			</FormItem>
		</Col>
	);
}
